import { Alert } from 'antd';
import { Wifi, WifiOff } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function OfflineDetector() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOfflineAlert, setShowOfflineAlert] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOfflineAlert(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOfflineAlert(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showOfflineAlert) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[9999] animate-pulse">
      <Alert
        message={
          <div className="flex items-center gap-2">
            <WifiOff className="size-5" />
            <span className="font-semibold">İnternet Bağlantısı Yok</span>
          </div>
        }
        description="Lütfen internet bağlantınızı kontrol edin. Bağlantı kesildiğinde bazı işlevler çalışmayabilir."
        type="error"
        banner
        closable={false}
        showIcon={false}
      />

      {/* Reconnection status */}
      {isOnline && (
        <Alert
          message={
            <div className="flex items-center gap-2">
              <Wifi className="size-5" />
              <span className="font-semibold">İnternet Bağlantısı Yeniden Kuruldu</span>
            </div>
          }
          description="İnternet bağlantınız başarıyla yeniden kuruldu."
          type="success"
          banner
          closable
          onClose={() => setShowOfflineAlert(false)}
          showIcon={false}
        />
      )}
    </div>
  );
}
